import React, { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useSwipeable } from 'react-swipeable'
import { withTheme } from 'styled-components'

import { Box, Link, Text } from 'pcln-design-system'

import { ROWS, TIERS } from '../constants'
import { BenefitsTableCell } from './BenefitsTableCell'
import { MobileTabs } from './MobileTabs'
import {
  BenefitRowLabel,
  BenefitRowLabelContent,
  BenefitsCard,
  BenefitsTableTierBadge,
  Table,
  Td,
  TierLabel,
} from './styledComponents'

export function doTabNavigation({ activeTab, direction }) {
  const currentIndex = TIERS.indexOf(activeTab)

  const mutation = direction === 'left' ? 1 : -1
  let newIndex = currentIndex + mutation

  if (newIndex <= 0) {
    newIndex = 0
  } else if (newIndex >= TIERS.length - 1) {
    newIndex = TIERS.length - 1
  }

  return TIERS[newIndex]
}

const getHeaderRow = (rows, isVipPlatinum20) => {
  const headerRow = rows.find(({ name }) => name === 'header')
  if (isVipPlatinum20) {
    return {
      ...headerRow,
      platinum: headerRow?.platinum?.replace('25', '20'),
    }
  }
  return headerRow
}

const BenefitsTable = ({
  rows = ROWS,
  activeMobileTab = 'member',
  theme,
  className,
  id = 'benefits-table',
  isVipPlatinum20 = false,
  navigationHandler = () => {},
}) => {
  const headerRow = getHeaderRow(rows, isVipPlatinum20)
  const contentRows = rows.filter(({ name }) => name !== 'header')

  const [activeTab, setActiveTab] = useState(activeMobileTab)
  // for dot pagination
  // const activeTabIndex = TIERS.indexOf(activeTab)

  useEffect(() => {
    if (TIERS.indexOf(activeTab) === -1) {
      setActiveTab(activeMobileTab)
    }
  }, [activeTab, activeMobileTab])

  const selectTab = (level) => {
    setActiveTab(level)
    navigationHandler('tab', null, level)
  }

  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.xl})`,
  })

  const onSwipedLeft = () => {
    const activeTabName = doTabNavigation({
      activeTab,
      direction: 'left',
    })
    setActiveTab(activeTabName)
    navigationHandler('swipe', 'left', activeTabName)
  }
  const onSwipedRight = () => {
    const activeTabName = doTabNavigation({
      activeTab,
      direction: 'right',
    })
    setActiveTab(activeTabName)
    navigationHandler('swipe', 'right', activeTabName)
  }
  const handlers = useSwipeable({ onSwipedLeft, onSwipedRight })

  return (
    <BenefitsCard
      id={id}
      boxShadowSize='md'
      borderRadius={2}
      mb={5}
      pt={[0, null, null, null, 2]}
      color='background.lightest'
      className={className}
      {...handlers}
    >
      {isMobile ? (
        <Box color='primary.dark'>
          <MobileTabs activeTab={activeTab} onSelect={selectTab} headerRow={headerRow} />
        </Box>
      ) : null}

      <Table>
        {headerRow && !isMobile ? (
          <thead>
            <tr>
              <th>{headerRow.label}</th>

              {TIERS.map((level) => (
                <th key={level}>
                  <BenefitsTableTierBadge size='large' level={level} pl={3}></BenefitsTableTierBadge>
                  <hr />
                  <TierLabel>{headerRow[level]}</TierLabel>
                </th>
              ))}
            </tr>
          </thead>
        ) : null}
        <tbody>
          {contentRows.map((row) => (
            <tr key={`benefitsTable-${row.name}`}>
              <BenefitRowLabel>
                <BenefitRowLabelContent hasLabelLink={!!row.labelLink}>{row.label}</BenefitRowLabelContent>
                {row.labelLink && (
                  <Link href={row.labelLink.href} target='_blank'>
                    <Text mt={-1} mr={[1, null, null, 2]} fontSize={[0, 0, 1]} textAlign='right'>
                      {row.labelLink.text}
                    </Text>
                  </Link>
                )}
              </BenefitRowLabel>

              {TIERS.map((level) => {
                if (isMobile && level !== activeTab) {
                  return null
                }

                return (
                  <Td key={level}>
                    <BenefitsTableCell row={row} vipTierName={level} />
                  </Td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </BenefitsCard>
  )
}

const BenefitsTableWithTheme = withTheme(BenefitsTable)
export { BenefitsTableWithTheme as BenefitsTable }
export default BenefitsTableWithTheme
